import { defineComposable } from '@/core/utils/defineComposable'

import { updateTeamUsageLimit } from '@/backend/darwin'
import type { ApiResult } from '@/backend/darwin/types'

import { ProductType } from './types'
import { useBillingInfoLoader } from './useBillingInfoLoader'
import { useCreditUsageLoader } from './useCreditUsageLoader'
import type { CustomerSubscriptionPayload } from './types'

export const useClientLimits = defineComposable(() => {
  const billingInfoLoader = useBillingInfoLoader()
  const creditUsageLoader = useCreditUsageLoader()

  /**
   * Set subscription amount on customer, for a specific product type.
   */
  const set = async ({
    clientSlug,
    partnerId,
    value,
    type,
  }: {
    clientSlug: string
    partnerId: number
    value: number
    type: ProductType.AnnotationCredits | ProductType.Storage
  }): Promise<ApiResult<CustomerSubscriptionPayload>> => {
    const params =
      type === ProductType.AnnotationCredits
        ? { credits: value, teamSlug: clientSlug }
        : { storage: value, teamSlug: clientSlug }

    const response = await updateTeamUsageLimit(params)

    if (response.ok) {
      billingInfoLoader.load(partnerId)
      if (type === ProductType.AnnotationCredits) {
        creditUsageLoader.loadUsage()
      }
    }

    return response
  }

  return { set }
})
